import React from "react";
import { useNavigate } from "react-router-dom";

const MnuSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen w-full bg-slate-950 text-white">
      <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6 md:px-8">
        <div className="rounded-3xl border border-white/10 bg-slate-900/80 p-8 shadow-2xl backdrop-blur-md">
          <h1 className="mb-6 text-4xl font-extrabold text-emerald-300 md:text-5xl">
            Erfolg entsteht aus klaren nächsten Schritten
          </h1>

          <p className="mb-10 max-w-3xl text-lg text-slate-200/90">
            Experts4Europe zeigt nicht nur offene Stellen, sondern macht Fortschritt sichtbar. Du erkennst, wo du
            gerade stehst, was dich stärkt und welcher nächste Schritt wirklich zählt.
          </p>

          <section className="mb-12">
            <h2 className="mb-3 text-2xl font-bold text-white md:text-3xl">Was Erfolg hier bedeutet</h2>
            <ul className="list-disc space-y-4 pl-6 text-slate-200/90">
              <li><strong>Mehr Sichtbarkeit:</strong> Dein Profil wird für passende Arbeitgeber leichter auffindbar.</li>
              <li><strong>Bessere Bewerbung:</strong> CV, Skills und Referenzen ergeben ein stärkeres Gesamtbild.</li>
              <li><strong>Klare Chancen:</strong> Du siehst neue passende Stellen statt nur allgemeiner Jobmassen.</li>
              <li><strong>Echte Fortschritte:</strong> Wochenlogik, Bestwerte und Erfolge bleiben nachvollziehbar.</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="mb-3 text-2xl font-bold text-white md:text-3xl">Wie Experts4Europe unterstützt</h2>
            <ul className="list-disc space-y-4 pl-6 text-slate-200/90">
              <li><strong>Mission Control:</strong> Die Startseite bündelt Lage, Vergleich, Chancen und nächsten Schritt.</li>
              <li><strong>Arbeitsräume:</strong> Bewerbung und Sprachtest sind fokussierte Bereiche statt unklarer Sammelseiten.</li>
              <li><strong>Erfolge:</strong> Medaillen und Fortschritt zeigen kleine und große Meilensteine.</li>
            </ul>
          </section>

          <div className="mt-12">
            <button
              onClick={() => navigate(-1)}
              className="rounded-xl bg-emerald-600/80 px-6 py-2 text-lg font-bold text-white shadow-xl transition duration-300 ease-in-out hover:bg-emerald-500/80"
            >
              Zurück
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MnuSuccess;
